// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import GrowthFormController from "./growth_form_controller"
application.register("growth-form", GrowthFormController)

import SegmentFormController from "./segment_form_controller"
application.register("segment-form", SegmentFormController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)
